import { useQuery } from '@apollo/client';
import { FormControl, InputLabel, MenuItem, Select, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { format } from 'date-fns';
import { orderBy } from 'lodash';
import { GET_ORGANIZATIONS } from 'src/graphql/organizations/queries';

export const OrganizationSelect = ({
  disabled,
  selectedOrganization,
  setSelectedOrganization = () => {},
  showClearButton = false,
  includeExpired = false,
}) => {
  const endDate = format(new Date(), 'yyyy-MM-dd');
  const { data: organizationsData } = useQuery(GET_ORGANIZATIONS, {
    variables: {
      where: includeExpired
        ? undefined
        : {
            end_date: {
              _gte: endDate,
            },
          },
    },
  });

  return (
    <FormControl
      fullWidth
      sx={{ mb: 4 }}
      disabled={disabled}
      variant={disabled ? 'filled' : 'outlined'}
    >
      <InputLabel id="organization-select-label">Select Organization</InputLabel>
      <Select
        label={'Select Organization'}
        labelId="organization-select-label"
        onChange={(e) => setSelectedOrganization(e?.target?.value)}
        value={selectedOrganization || ''}
        MenuProps={{
          sx: { maxHeight: 400 },
        }}
      >
        {orderBy(organizationsData?.rows, 'name')?.map((org) => {
          return (
            <MenuItem key={org?.organization_id} value={org?.organization_id}>
              {org?.name}
            </MenuItem>
          );
        })}
      </Select>
      {showClearButton ? (
        <IconButton
          onClick={() => setSelectedOrganization()}
          sx={{ position: 'absolute', right: 24, top: 8 }}
        >
          <CloseIcon sx={{ color: 'text.secondary' }} />
        </IconButton>
      ) : null}
    </FormControl>
  );
};
